import { velocityHelpers } from 'velocity-react';
/* tslint:disable-next-line */
import 'velocity-animate/velocity.ui';

const fx = velocityHelpers.registerEffect;

const itemHeight = 128;

export const MediumItemAnimations = {
  In: fx({
    defaultDuration: 500,
    calls: [
      [{ height: [60, 0] }, 2 / 5],
      [{
        translateX: [0, 360],
      }, 3 / 5, { easing: 'easeOutSine' }],
    ],
  }),
  Out: fx({
    defaultDuration: 500,
    calls: [
      [{
        translateX: 360,
      }, 3 / 5, { easing: 'easeInSine' }],
      [{
        height: 0,
      }, 2 / 5],
    ],
    reset: { height: itemHeight },
  }),
};

export const UsageItemAnimations = {
  In: fx({
    defaultDuration: 500,
    calls: [
      [{ height: itemHeight }, 1 / 100],
      [{
        translateX: [0, -360],
      }, 99 / 100, { easing: 'easeOutSine' }],
    ],
  }),
  Out: fx({
    defaultDuration: 500,
    calls: [
      [{
        translateX: -360,
      }, 3 / 5, { easing: 'easeInSine' }],
      [{
        height: 0,
        padding: 0,
        margin: 0,
      }, 2 / 5],
    ],
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectMedia/animations.ts